// @flow @format
import {connect} from 'react-redux';
import MachineSelect from '../components/MachineSelect';

import type {State} from '../reducers';

const mapStateToProps = ({selection, entities}: State) => {
	return {
		userId: selection.userId,
		machine: entities.machines.entities[selection.machineId],
		machines: entities.machines.byUser[selection.userId],
	};
};

export default connect(mapStateToProps)(MachineSelect);



// WEBPACK FOOTER //
// ./src/containers/MachineSelectContainer.js